import { Outlet, useLocation } from '@tanstack/react-router';

import { CountrySelector } from 'common/components/cookbook/CountrySelector/CountrySelector';
import { NavigationBar } from 'common/components/cookbook/NavigationBar/NavigationBar';
import { MobileSearchInput } from 'common/components/cookbook/Search/MobileSearchInput';
import { ViewMeta } from 'common/components/cookbook/ViewMeta';
import { useFeatureEnabled } from 'common/feature-flag/hooks/useFeatureEnabled';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useMatchMedia } from 'common/hooks/useMatchMedia';
import { useSelectedCountryCodes } from 'common/hooks/useSelectedCountryCodes';
import { useSetSearch } from 'common/hooks/useSetSearch';

import { vendorsLayoutRoute } from '..';
import { FundingsNavBarControls } from './FundingsNavBarControls';
import { FundingsSearchInput } from './FundingsSearchInput';
import { VendorsNavBarControls } from './VendorsNavBarControls';
import { VendorsSearchInput } from './VendorsSearchInput';
import { VendorsTabs } from './VendorsTabs';

export function VendorsLayout() {
  const formatMessage = useFormatMessage();
  const countryCodes = useSelectedCountryCodes();

  const promotionsEnabled = useFeatureEnabled('vendor-promotions', countryCodes);

  const setSearch = useSetSearch(vendorsLayoutRoute);

  const location = useLocation();

  const isVendorsView = location.pathname.endsWith('/vendors');
  const isFundingsView = location.pathname.endsWith('/vendors/fundings');

  const isMobile = useMatchMedia('maxMd');

  const pageTitle = formatMessage('common.vendors');
  return (
    <ViewMeta title={pageTitle} dataTestId="vendors">
      <NavigationBar
        title={pageTitle}
        titleContent={<CountrySelector onChange={() => setSearch({ page: undefined })} />}
        rightContent={
          <>
            {isVendorsView && <VendorsNavBarControls />}
            {isFundingsView && <FundingsNavBarControls />}
          </>
        }
        disableBottomContentPadding
        bottomContent={
          <>
            {isMobile && isVendorsView && (
              <MobileSearchInput searchInput={<VendorsSearchInput />} />
            )}
            {isMobile && isFundingsView && (
              <MobileSearchInput searchInput={<FundingsSearchInput />} />
            )}
            {promotionsEnabled && <VendorsTabs />}
          </>
        }
      />
      <Outlet />
    </ViewMeta>
  );
}
